export default {
  downloadPlanJson: 'Descargar JSON del Plan',
  downloadModelJson: 'Descargar JSON del Modelo',
  preparingPlanDownload: 'Preparando los datos de tu plan para descargar...',
  preparingModelDownload: 'Preparando los datos de tu modelo para descargar...',
  tryAgain: 'Intentar de Nuevo',
  planDownloadSuccess: '¡Los datos de tu plan se han descargado exitosamente!',
  modelDownloadSuccess: '¡Los datos de tu modelo se han descargado exitosamente!',
  closeTabMessage: 'Puedes cerrar esta pestaña ahora.',
  readyToDownloadPlan: 'Listo para descargar el JSON de tu plan.',
  readyToDownloadModel: 'Listo para descargar el JSON de tu modelo.',
  downloadModelPklFiles: 'Descargar Archivos PKL del Modelo',
  loadingPklInfo: 'Cargando información de archivos PKL...',
  pklFilesDescription: 'Descarga los archivos PKL asociados con este modelo:',
  downloadModelPkl: 'Descargar PKL del Modelo',
  modelPklNotAvailable: 'Archivo PKL del modelo no disponible',
  downloadPlanPkl: 'Descargar PKL del Plan',
  planPklNotAvailable: 'Archivo PKL del plan no disponible',
  noPklFilesAvailable: 'No hay archivos PKL disponibles para este modelo.',
  pklReasonUnauthorized: 'Tu cuenta no tiene permiso para leer los archivos del modelo. Solo Scientists y Admins pueden descargar archivos PKL.',
  pklReasonNotFound: 'No se encontró el archivo en storage en {path}.',
  pklReasonUnknown: 'Storage devolvió un error: {error}',
  pklReasonNoPath: 'No se pudo determinar la ubicación en storage de este archivo PKL a partir de los datos del modelo.',
  deletedPlanTitle: 'Este plan fue eliminado',
  deletedPlanExplanation: 'Se muestra la copia guardada cuando el plan se envió a ejecutar. Contiene solo los datos de entrada del plan, sin resultados.',
  deletedPlanQueuedOn: 'Copia guardada el {date}',
  deletedModelTitle: 'Este modelo fue eliminado',
  deletedModelExplanation: 'Se muestra el modelo tal como estaba al eliminarse, guardado en la papelera hasta que se purgue. Sus archivos PKL y sus planes siguen disponibles hasta entonces.',
  deletedModelDeletedOn: 'Eliminado el {date}',
  deletedModelDeletedOnBy: 'Eliminado el {date} por {name}',
  deletedModelPurgeOn: 'Se purgará el {date}',
  modelNotFound: 'No se encontró el modelo. Puede haber sido eliminado hace más de 7 días.',
  planNotFound: 'No se encontró el plan.',
  permissionDenied: 'Tu cuenta no tiene permiso para exportar estos datos. Solo Scientists y Admins pueden hacerlo.',
  openModelOverview: 'Abrir Resumen del Modelo',
  openModelError: 'No se pudo abrir este modelo. Es posible que tu cuenta no tenga acceso a él.',
  authenticationRequired: 'Se requiere autenticación. Por favor inicia sesión para descargar datos.',
  noDataFound: 'No se encontraron datos para los ID(s) especificados',
  exportError: 'Ocurrió un error al exportar los datos'
}
